export default "__VITE_ASSET__l_ey7ga5__"